var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTTable',{attrs:{"title":"Forma Jurídica","subtitle":"Lista de Forma Jurídica","fields":_vm.fields,"items":_vm.$store.state.formaJuridica.formasJuridicas},on:{"delete":function($event){return _vm.deleteItem($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }